import React from "react";
import GetStartedBtn from "./button";
import "./manage.css";
import "./button.css";

const Section3 = (props) => {
  window.addEventListener("load", () => {
    document.querySelector("body").classList.add("loaded");
  });
  return (
    <div className="section3-container">
      <div className="button-container">
        <GetStartedBtn btn="manage-btn body-btn" />
      </div>
      <div className="orange-section">
        <div className="orange-left">
          <p>
            Simplify how your team <br /> works today.
          </p>
        </div>
        <div className="orange-right">
          <div className="button-container">
            <GetStartedBtn btn="manage-btn body-btn white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
